import { formMatchesSearchQuery } from './formTableSearch';
import {
  FormData,
  FormStatusFilter,
  FormStatusTab,
  mapFilterToStatusTab,
} from './types';

export interface FormTableFilterState {
  searchQuery: string;
  selectedStatuses: FormStatusFilter[];
}

function normalizedStatuses(
  selectedStatuses: FormStatusFilter[],
): FormStatusFilter[] {
  return selectedStatuses.filter((s) => s !== FormStatusFilter.ALL);
}

export function filterForms(
  forms: FormData[],
  { searchQuery, selectedStatuses }: FormTableFilterState,
): FormData[] {
  const statuses = normalizedStatuses(selectedStatuses);
  const matchingStatusTabs =
    statuses.length === 0
      ? null
      : statuses
          .map(mapFilterToStatusTab)
          .filter((tab): tab is FormStatusTab => tab !== null);

  return forms
    .filter((form) => {
      if (matchingStatusTabs == null) return true;
      return matchingStatusTabs.includes(form.status);
    })
    .filter((form) => formMatchesSearchQuery(form, searchQuery));
}

export function hasActiveFilters(
  searchQuery: string,
  selectedStatuses: FormStatusFilter[],
): boolean {
  const statuses = normalizedStatuses(selectedStatuses);
  return searchQuery.trim() !== '' || statuses.length > 0;
}
